import type { StoreState } from '../../state-types';

/** Check if it's ok (form dirty..) to switch to a new Core Question form */
export const checkIsOkToSwitchCoreQuestionForm =
    (activeCardId: string = '', coreQuestionId: string = '') =>
    (state: StoreState): boolean => {
        // no form is active currently, allow to switch
        if (!activeCardId) {
            return true;
        }

        const isFormDirty = state.uiCoreQuestionForm.isDirty;
        const isSelected = coreQuestionId === activeCardId;

        // form is active, no need to switch
        if (isSelected) {
            return false;
        }

        // form is dirty, needs confirmation from user
        if (isFormDirty) {
            const msg =
                'You have unsaved changes. Are you sure you want to proceed without saving?';
            return window.confirm(msg);
        }

        return true;
    };
